import { render, staticRenderFns } from "./ShowPostUpload.vue?vue&type=template&id=3358135a"
import script from "./ShowPostUpload.vue?vue&type=script&lang=js"
export * from "./ShowPostUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports